// src/scenes/paymentcollection/index.jsx
import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { useMode, ColorModeContext } from '../../theme';
import PaymentCollectionForm from '../../component-files/Forms/PaymentCollectionForm';

const PaymentCollectionPage = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [open, setOpen] = useState(true);

    // Force this page into light mode
    const [lightTheme, colorMode] = useMode('light');

    const [firstName = '', ...rest] = (params.get('student') || '').split(' ');
    const studentInfo = {
        firstName,
        lastName: rest.join(' '),
        schoolName: params.get('site') || '',
        apiid: params.get('apiid') || '',
        accountBalance: Number(params.get('balance')) || 0,
    };

    return (
        <ColorModeContext.Provider value={colorMode}>
            <ThemeProvider theme={lightTheme}>
                <CssBaseline />
                {/* Hardcoded white background for full viewport */}
                <Box sx={{ bgcolor: '#ffffff', minHeight: '100vh', p: 0, m: 0 }}>
                    <PaymentCollectionForm
                        open={open}
                        onClose={() => { setOpen(false); navigate('/'); }}
                        onSubmit={(payload) => { console.log(payload); /* post to API */ }}
                        studentInfo={studentInfo}
                    />
                </Box>
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
};

export default PaymentCollectionPage;